import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';

import LocalStorage, { StorageKeys } from 'utils/local-storage';
import logger from 'utils/logger';

// return the current user session
export const getCurrentSession = (): Promise<CognitoUserSession | null> => {
  return Auth.currentSession().catch(error => {
    logger.error({ error, message: 'remote/auth Auth.currentSession() Error' });
    // if cognito failed to get a valid session
    // clear local storage to prevent a user with
    // no session from being "logged in" in app state
    LocalStorage.setItem(StorageKeys.USER, null);
    return null;
  });
};

// This method should get us information about a user being signed-in
// without validating the session with the cognito server. If this does
// not do that we should just move to keep track of a user being signed-in
// or not via localstorage
export const userHasSignedIn = (): Promise<boolean> => {
  return Auth.currentAuthenticatedUser()
    .then(credentials => !!credentials)
    .catch(() => false);
};

// Return if there is an unexpected sign outs tracking
export const checkForUnexpectedSignOut = (): Promise<boolean> =>
  Auth.currentSession()
    .then(() => {
      // Add a marker when a user is successfully sign in to track unexpected sign outs
      LocalStorage.setItem(StorageKeys.USER_SIGNED_IN_SUCCESSFULLY, true);
      return false;
    })
    .catch(() => {
      // First check if the user has been logged in successfylly
      const userSignedInSuccessfully = LocalStorage.getItem(
        StorageKeys.USER_SIGNED_IN_SUCCESSFULLY
      );
      if (userSignedInSuccessfully) {
        // Remove the marker and return that there has been an unexpected sign out
        LocalStorage.removeItem(StorageKeys.USER_SIGNED_IN_SUCCESSFULLY);
        return true;
      }
      return false;
    });
